import React from "react";

export default function AuditOverviewTab({ summary, actions, onOpenAudit }) {
  const s = summary || {};
  const totals = [
    { key: "overdue_audits", label: "Overdue audits", tone: "text-red-700", bar: "bg-red-500", count: (actions?.overdue_audits || []).length },
    { key: "low_score", label: "Low-scoring (<70%)", tone: "text-amber-700", bar: "bg-amber-500", count: (actions?.low_score || []).length },
    { key: "overdue_actions", label: "Overdue actions", tone: "text-red-700", bar: "bg-red-500", count: (actions?.overdue_actions || []).length },
    { key: "unresolved_significant", label: "Significant unresolved findings", tone: "text-red-700", bar: "bg-red-500", count: (actions?.unresolved_significant || []).length },
  ];
  const top = [...(actions?.overdue_actions || []).map(x => ({ ...x, kind: "overdue" })),
               ...(actions?.unresolved_significant || []).map(x => ({ ...x, kind: "significant" }))].slice(0, 8);

  return (
    <div className="space-y-4" data-testid="audits-qa-overview">
      <section className="bg-white border border-slate-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-3">
          <div>
            <h2 className="font-heading text-base font-semibold text-slate-900">Quality Snapshot</h2>
            <p className="text-xs text-slate-500 mt-0.5">Live view of your audit programme.</p>
          </div>
          <div className="text-right">
            <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">Total Audits</div>
            <div className="font-heading text-xl font-semibold text-slate-900 tabular-nums">{s.audits_total ?? "—"}</div>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
          {totals.map((t) => (
            <div key={t.key} className="flex items-start gap-2">
              <span className={`inline-block w-2 h-2 rounded-full mt-1.5 ${t.bar}`} />
              <div>
                <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{t.label}</div>
                <div className={`font-heading text-sm font-semibold tabular-nums ${t.tone}`}>{t.count}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white border border-slate-200 rounded-lg p-6">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-heading text-base font-semibold text-slate-900">Attention Items</h2>
          <span className="text-xs text-slate-500 tabular-nums">{actions?.total || 0} total</span>
        </div>
        {top.length === 0 ? (
          <div className="text-sm text-slate-500 py-8 text-center">No open actions or significant findings.</div>
        ) : (
          <ul className="divide-y divide-slate-100" data-testid="overview-attention-list">
            {top.map((a, i) => (
              <li key={i} className="py-2.5 flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <button onClick={() => onOpenAudit?.(a.audit_id)} className="text-sm font-medium text-slate-900 hover:text-sky-700 truncate max-w-[380px] text-left" data-testid={`overview-open-${a.audit_id}`}>
                    {a.audit_title || "—"}
                  </button>
                  <div className="text-xs text-slate-500 truncate">{a.finding}</div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  {a.due_date && <span className="text-[11px] text-slate-500 tabular-nums">{a.due_date}</span>}
                  <span className={`inline-flex items-center text-[10px] uppercase tracking-wider font-semibold px-1.5 py-0.5 rounded-full border ${a.kind === "overdue" ? "bg-red-100 text-red-800 border-red-200" : "bg-amber-100 text-amber-900 border-amber-300"}`}>
                    {a.kind === "overdue" ? "Overdue" : a.priority || "Significant"}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
